import type { Size } from '@ps/web-core-store';
import React from 'react';

export interface ModalContextValue {
  setStyle(state: {
    size?: Size;
    className?: string;
    overlayClassName?: string;
    transparentBackground?: boolean;
    hidden?: boolean;
    closeOnOverlayClick?: boolean;
    closeOnEsc?: boolean;
  }): void;
}

export const ModalContext = React.createContext<ModalContextValue>({
  setStyle: () => undefined
});
